module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-700-472.7702a69.woff2";